import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../../utils/config-service';
import { Observable } from 'rxjs/Observable';
import { LineGraphData, LineGraph } from '../../models/linegraphData';
import { PerspectiveGraphValue } from '../../models/perspectiveGraphValue';
import { downloadUrl } from '../../../../utils/xhrDownloader';

import * as _ from 'lodash';

@Injectable()
export class LinegraphApiService {
    private lineGraphApi: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.lineGraphApi = this.configService.getEnv('lineGraphApi');
    }

    getLineGraph(date: Date, jobId: string): Observable<{} | LineGraph> {
        let url = this.lineGraphApi + jobId + '/' + this.formatDate(date);

        return this.http.get(url)
            .map((result: any) => {
                let json = result;
                if (json) {
                    return new LineGraph(json);
                }
            })
            .catch((error: any) => {
                throw error;
            });
    }

    getMultiDaylineGraph(jobId: string, dates: Date[]): Observable<{} | LineGraph[]> {
        let formattedDates = dates.map((date: Date) => this.formatDate(date));
        let url = this.lineGraphApi + jobId;
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.post(url, JSON.stringify(formattedDates), { headers: headers })
            .map((result: any) => {
                if (result) {
                    return result.map((dataJson: any) => new LineGraph(dataJson));
                }
            })
            .catch((error: any) => {
                throw error;
            });
    }

    getPerspective(jobId: string, dayOfWeek: number): Observable<{} | PerspectiveGraphValue> {
        let url = this.lineGraphApi + jobId + '/historical/' + dayOfWeek;

        return this.http.get(url)
            .map((result: any) => {
                return new PerspectiveGraphValue(result);
            })
            .catch((error: any) => {
                throw error;
            });
    }

    getLineGraphCsv(jobId: string, dates: Date[], filename: string): void {
        let formattedDates = dates.map((date: Date) => this.formatDate(date));
        let url = this.lineGraphApi + jobId + '/csv';
        let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        headers.append('response-content', 'text/csv');
        let fullFileName = filename + '-lineGraph.csv';

        downloadUrl(url, formattedDates, fullFileName);
    }

    private formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) { month = '0' + month; }
        if (day.length < 2) { day = '0' + day; }

        return [year, month, day].join('-');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/linegraph/linegraph.api.service.ts